/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { queryAllByAttribute, queryByAttribute } from '@testing-library/preact';
import { expect } from 'chai';

export const queryById = queryByAttribute.bind(null, 'id');

export function queryAllBy(attribute: string) {
  return queryAllByAttribute.bind(null, attribute);
}

export const queryByItemIndex = queryByAttribute.bind(null, 'data-oj-private-item-index');

export function checkTooltipText(content: string) {
  const targetElements = document.querySelectorAll('[role="tooltip"]');
  const targetElementItem = targetElements.item(0) as HTMLElement;
  const tooltipContainer = targetElementItem?.firstElementChild as HTMLElement;
  expect(tooltipContainer?.style.opacity).not.equals('');
  expect(tooltipContainer?.style.opacity).not.equals('0');
  expect(tooltipContainer?.style.maxHeight).not.equals('');
  expect(tooltipContainer?.style.maxHeight).not.equals('0');
  const innerHTML = tooltipContainer?.firstElementChild?.innerHTML;
  expect(innerHTML).equals(content);
}

export function checkStringContent(content: string) {
  const targetElements = document.querySelectorAll('[role="tooltip"]');
  const targetElementItem = targetElements.item(0) as HTMLElement;
  expect(
    Array.from(targetElementItem.classList).some((className) =>
      className.includes('useDatatip_visDatatipStyle')
    )
  ).to.equal(true);
  expect(targetElementItem?.innerHTML).to.equal(content);
}

export function checkRatingGaugeCustomContent(datatip: HTMLElement) {
  expect(
    Array.from(datatip.classList).some((className) =>
      className.includes('useDatatip_visDatatipStyle')
    )
  ).to.equal(true);
  const ratingGauge = datatip.querySelector('[role="slider"]') as HTMLElement;
  expect(ratingGauge).to.not.equal(null);
  expect(ratingGauge.getAttribute('aria-valuenow')).to.equal('3');
}

export function checkNoBorder(element: HTMLElement) {
  expect(element.style.border).to.equal('');
  expect(element.style.borderStyle).to.be.oneOf(['', 'none']);
}

export function checkBorderColor(datatip: HTMLElement, borderColor: string) {
  expect(datatip.style.borderColor).to.equal(borderColor);
}
